export const WARNING_MESSAGES = {
  sep: 'Warning: The sample does not provide the minimal cutwidth of 100 mm. SEP/SEPD Analysis will be flawed.',
};
